import React, { ChangeEvent, FC, useEffect, useState, useRef } from 'react'
import { Button, Divider, Form, Input, Typography } from 'antd'
import { toast } from 'react-toastify'
import api from '../../helpers/api'
import Turnstile from 'react-turnstile'

const { Text } = Typography

interface VerifyResponse {
    ref: string
    transaction_id: string
    token: string
    status: boolean
}
interface RegisterStepVerifyOTPProps {
    isSubmitting: boolean
    phone: string
    verifyRef: string
    tokenTurnstileOTP: string
    prefixInfo?: any
    setVerifyRefOTP: (e: any) => void
    setVerifyTransactionID: (e: any) => void
    setVerifyTokenOTP: (e: any) => void
    setStep: (e: any) => void
    setStepOTP: (e: any) => void
    setOTPForm: (e: any) => void
    handleSubmit: (e: ChangeEvent<any>) => void
    setTokenTurnstileOTP: (e: any) => void
}
const RegisterStepVerifyOTP: FC<RegisterStepVerifyOTPProps> = ({
    isSubmitting,
    phone,
    verifyRef,
    tokenTurnstileOTP,
    prefixInfo,
    setVerifyRefOTP,
    setVerifyTransactionID,
    setVerifyTokenOTP,
    setStep,
    setStepOTP,
    setOTPForm,
    handleSubmit,
    setTokenTurnstileOTP
}) => {
    const [otp, setOTP] = useState<string[]>(["", "", "", ""]);
    const inputRefs = useRef<any>([]);
    const OTP_Delay = 180
    const [timer, setTimer] = useState(OTP_Delay);
    const [resetCounter, setResetCounter] = useState(0);
    const [back, setBack] = useState<boolean>(false);


    const handleOTPInputChange = (
        e: React.ChangeEvent<HTMLInputElement>,
        index: number
    ) => {
        const { value } = e.target;
        const newOTP = [...otp];
        newOTP[index] = value;
        setOTP(newOTP);
        setOTPForm(newOTP.join(''))

        if (value === "" && index > 0 && back === false) {
            inputRefs.current[index - 1]?.focus({
                cursor: 'all',
            });
        }

        if (value !== "") {
            inputRefs.current[index + 1]?.focus();
        }
    };

    const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
        const keyCode = event.keyCode || event.which;
        const keyValue = String.fromCharCode(keyCode);

        if (!/^\d+$/.test(keyValue)) {
            event.preventDefault();
        }
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>, index: number) => {
        const keyCode = e.keyCode || e.which;
        const keyValue = String.fromCharCode(keyCode);

        if (e.key === 'Backspace' && e.currentTarget.value === '') {
            setBack(true)
            inputRefs.current[index - 1]?.focus({
                cursor: 'all',
            });
            e.preventDefault();
        } else {
            setBack(false)
        }

        if (keyValue === e.currentTarget.value) {
            inputRefs.current[index + 1]?.focus({
                cursor: 'all',
            });
        }
    };

    const handleVerifyRefOTP = async () => {
        if (prefixInfo?.functions.otp_register) {
            setResetCounter((prevCounter) => prevCounter + 1);
            if (tokenTurnstileOTP === "") {
                toast.error('กรุณารอ Turnstile โหลดเสร็จสิ้น')
                setResetCounter((prevCounter) => prevCounter + 1);
                return
            }
        }
        setTimer(OTP_Delay);

        try {
            const values = {
                phone: phone,
                captcha: tokenTurnstileOTP
            }
            const res: VerifyResponse = await api.post('/register/step-1', values)
            if (res.status) {
                setVerifyRefOTP(res.ref)
                setVerifyTransactionID(res.transaction_id)
                setVerifyTokenOTP(res.token)
            } else {
                toast.error('กรุณารอสักครู่แล้วลองใหม่อีกครั้ง')
            }
        } catch ({ message }: any) {
            toast.error(message as string)
        } finally {

        }
    }

    useEffect(() => {
        const timerId = setInterval(() => {
            setTimer((prevTimer) => {
                if (prevTimer === 1) {
                    clearInterval(timerId);
                    return 0;
                }
                return prevTimer - 1;
            });
        }, 1000);
        return () => clearInterval(timerId);
    }, [timer]);

    useEffect(() => {
        if (phone === '' || verifyRef === '') {
            setStep(1)
            setStepOTP(false)
        }
    }, [phone, verifyRef]) // eslint-disable-line 

    useEffect(() => {
        if (prefixInfo.recaptcha.enable && resetCounter === 0) {
            setResetCounter((prevCounter) => prevCounter + 1);
        }
    }, [prefixInfo.recaptcha.enable])


    return (
        <div style={{ marginTop: 30 }}>
            <div className="register-title" style={{ textAlign: "center" }}>
                <Text type="secondary">กรอก OTP ที่ส่งไปยัง {phone && phone.replace(/(\d{3})\d{3}(\d{2})(\d{2})/, '$1*****$3')}</Text>
            </div>
            <div className="register-title" style={{ textAlign: "center" }}>
                <Text type="secondary">OTP Ref.{verifyRef}</Text>
            </div>
            <Divider />
            <Form.Item
                name="otp"
                rules={[
                    { required: true, message: "กรุณากรอก OTP" },
                    { len: 4, message: "OTP ต้องกรอกให้ครบ 4 หลัก" },
                ]}
            >
                <Input.Group className="otp-input-group">
                    {otp.map((digit, index) => (
                        <Input
                            key={index}
                            ref={(ref) => (inputRefs.current[index] = ref)}
                            value={digit}
                            maxLength={1}
                            onChange={(e) => handleOTPInputChange(e, index)}
                            onKeyPress={handleKeyPress}
                            onKeyDown={(e) => handleKeyDown(e, index)}
                            inputMode="numeric"
                            pattern="[0-9]*"
                        />
                    ))}
                </Input.Group>
            </Form.Item>
            <Form.Item>
                <Button
                    type="primary"
                    htmlType="submit"
                    shape="round"
                    loading={isSubmitting}
                    onClick={handleSubmit}
                    block>
                    ยืนยัน
                </Button>
            </Form.Item>
            {prefixInfo.functions.otp_register !== undefined && (
                (prefixInfo.recaptcha.enable && prefixInfo?.functions.otp_register && (
                    <div style={{ marginTop: "10px", marginBottom: "0" }}>
                        <Turnstile
                            key={resetCounter}
                            sitekey={prefixInfo.recaptcha.key}
                            theme="dark"
                            onVerify={(token) => setTokenTurnstileOTP(token)}
                            retry='auto'
                            autoResetOnExpire={true}
                        />
                    </div>
                ))
            )}
            <Form.Item style={{ textAlign: 'center' }}>
                {timer <= 0 ? (
                    <Button type="link" className="btn-reset-password" size="small" onClick={handleVerifyRefOTP}>ขอรหัส OTP ใหม่</Button>
                ) : (
                    <Button type="link" className="btn-reset-password" size="small" disabled>ขอรหัส OTP ใหม่ (รอ {timer} วินาที)</Button>
                )}
            </Form.Item>
        </div>
    )
}

export default RegisterStepVerifyOTP
